import { render, staticRenderFns } from "./multipleChoiceShare_dialog.vue?vue&type=template&id=1b269525"
import script from "./multipleChoiceShare_dialog.vue?vue&type=script&lang=js"
export * from "./multipleChoiceShare_dialog.vue?vue&type=script&lang=js"
import style0 from "./multipleChoiceShare_dialog.vue?vue&type=style&index=0&id=1b269525&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports